declare global {
    interface Window {
        $sleek: unknown;
        SLEEK_PRODUCT_ID: string;
    }
}

export function initSleek(productId: string) {
    window.$sleek = window.$sleek || []
    window.SLEEK_PRODUCT_ID = productId
    const scriptElement = document.createElement("script")
    scriptElement.async = true
    scriptElement.src = "https://client.sleekplan.com/sdk/e.js"
    document.head.appendChild(scriptElement)
}

